import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ROUTES from "../helpers/routes";

const router = createBrowserRouter(ROUTES);


const isMobile = () => {
	// Basic check for mobile devices
	return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const App = () => {
	// if (!isMobile() && process.env.NODE_ENV !== "development" && !window.location.pathname.includes("raffle") && !window.location.pathname.includes("admin")) {
	// 	return (
	// 		<div style={{
	// 			display: "flex",
	// 			justifyContent: "center",
	// 			alignItems: "center",
	// 			height: "90vh",
	// 			fontSize: "2rem",
	// 			textAlign: "center",
	// 			padding: "2rem"
	// 		}}>
	// 			Please view this website on your mobile device
	// 		</div>
	// 	);
	// }
	return (
		<div>
			<RouterProvider router={router} />
		</div>
	);
}

export default App;
